module.exports = __webpack_public_path__ + "static/supporters-jackwills-031e05c674aa5b1841273e09f51d2a94.svg";